import { useCallback, useMemo } from "react";
import { useApolloClient } from "@apollo/client";

import { useAppDispatch, useAppSelector } from "../../../Store";


import { gqlActions } from "../gqlData_Reducer";
import Graph_QL, { DynamicDataObk, GqlHook_Returns, StateDataObject } from "..";
import { noop } from "lodash";
import { filterByConnection } from "../filterByConnection";

import { BasicQueryInfoInput } from "../FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { GET_REPORT_TEMPLATE, ReportTemplateResponse } from "./GQLCalls/getReportsTemplateCall";
import { DeleteTemplateItem, ReportTemplateItem } from "./reportTemplateSlice";
import { ReportTemplate } from "../../../Definitions";
import { UPDATE_REPORT_TEMPLATE, UpdateReportTemplateResponse } from "./GQLCalls/updateReportTemplateCall";
import { DELETE_TEMPLATE, DeleteTemplateResponse } from "./GQLCalls/deleteReportTemplateCall";
import { CREATE_REPORT_TEMPLATE, CreateReportTemplateResponse } from "./GQLCalls/createReportTemplateCall";


export const useReportTemplate = (connection: Graph_QL.GQLCons): GqlHook_Returns<ReportTemplateItem, BasicQueryInfoInput >  => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  // const [, setCursorId] = useState(-1);

  const reportState = useAppSelector(({graphQlData:{domain}}) => domain.reportTemplate);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(reportState, Graph_QL.ToArr(connection)) as Record<string, ReportTemplateItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<ReportTemplateItem>)
  },[connection, reportState]);


  const getReportTemplates = useCallback(async (input: BasicQueryInfoInput, specific?: Graph_QL.GQLCons) => {
    const specificConnection = specific ? specific : connection;
    
    try {
      const templates = await client.query<ReportTemplateResponse>({query: GET_REPORT_TEMPLATE, variables: {...specificConnection.connection, input}, fetchPolicy: "no-cache"})
      if (templates && templates.data) {
        dispatch({type: String(gqlActions.domain.reportTemplate.maintained), payload: {con: specificConnection.connection, data: templates.data.report.template}}) 
      }
    } catch (error) {
      console.log(error)
    }

  },[client, connection, dispatch])


  const maintainEntries = async (updatedTemplate?: Partial<DynamicDataObk<ReportTemplate>>, deletedTemplate?: Partial<DeleteTemplateItem>, createTemplates?: Partial<DynamicDataObk<Omit<ReportTemplate, "templateId">>>) => {
    try {
      if (updatedTemplate?.data) {
        const updateResult = await client.mutate<UpdateReportTemplateResponse>({mutation: UPDATE_REPORT_TEMPLATE, variables: {...connection.connection,  ...updatedTemplate.data}, fetchPolicy: "no-cache"})
        if (updateResult && updateResult.data) {
          dispatch({type: String(gqlActions.domain.reportTemplate.maintained), payload: {con: connection.connection, data: updateResult.data.report.updateTemplate}})
        }
      }

      if (deletedTemplate?.data?.length) {
        const deleteResult = await client.mutate<DeleteTemplateResponse>({mutation: DELETE_TEMPLATE, variables: {...connection.connection, ids: deletedTemplate.data}, fetchPolicy: "no-cache"})
        if (deleteResult && deleteResult.data && deleteResult.data.report.deleteTemplate.success) {
          dispatch({type: String(gqlActions.domain.reportTemplate.deleteEntries), payload: {con: connection.connection, data: deletedTemplate.data}})
        }
      }
      
      if (createTemplates?.data) {
        const createResult = await client.mutate<CreateReportTemplateResponse>({mutation: CREATE_REPORT_TEMPLATE, variables: {...connection.connection, ...createTemplates.data}, fetchPolicy: "no-cache"})
        if (createResult && createResult.data) {
          dispatch({type: String(gqlActions.domain.reportTemplate.maintained), payload: {con: connection.connection, data: createResult.data.report.createTemplate}})
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  return {call: getReportTemplates, fetchMore: noop, deleteEntries: noop, data: fullState, maintainEntries}
} 

